module.exports = __webpack_public_path__ + "static/img/qiehuan2.855226b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/qiehuan2.jpg
// module id = HdpX
// module chunks = 41